// NOTE(liamvdv): changes in the query params on background pings will trigger a re-render
// This is a workaround to prevent re-rendering of the same URL (incurring network requests / ingress costs / battery drain)
const urlCache = new Map<string, string>();

export function getFirstDownloadUrl(url: string): string {
  const [core] = url.split("?", 1);

  if (!urlCache.has(core)) {
    urlCache.set(core, url);
  }
  return urlCache.get(core)!;
}

